import React from 'react';

const ShippingTable = ({ item, isView, shippingData, updateShipping, vendors, shippingMethods }) => {
  return (
    <div>
      <span className="label-text font-weight-bold">Shipping Rates &amp; Methods</span>
      <table className="card-table">
        <thead>
          <tr>
            <th>Tier</th>
            {vendors.map(v => (
              <th key={v.key} className={`text-center ${v.key}-header`}>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  {v.flagImg && <img src={v.flagImg} alt="" style={{ width: 14, height: 10 }} />}
                  {v.label.toUpperCase()}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {item.tiers.map((tier, tIdx) => (
            <tr key={tier.id}>
              <td className="tier-cell">
                <span className="font-weight-bold">Tier {tIdx + 1}</span>
                <span className="weight-tag">
                  Total: {((Number(item.unitWeight) || 0) * (Number(tier.quantity) || 0)).toFixed(2)} kg
                </span>
              </td>
              {vendors.map(v => (
                <td key={v.key}>
                  <div className="d-flex flex-column justify-content-center gap-2">
                    <div className="currency-input-wrapper rate-input-cell">
                      <span>$</span>
                      <input
                        type="number"
                        step="0.01"
                        placeholder="Rate/kg"
                        disabled={isView}
                        value={shippingData[item.id]?.[v.key]?.[tier.id]?.ratePerKg || ''}
                        onChange={e => updateShipping(item.id, v.key, tier.id, 'ratePerKg', e.target.value)}
                      />
                    </div>
                    <select
                      className="method-cell"
                      disabled={isView}
                      value={shippingData[item.id]?.[v.key]?.[tier.id]?.method || ''}
                      onChange={e => updateShipping(item.id, v.key, tier.id, 'method', e.target.value)}>
                      <option value="">Select Method</option>
                      {shippingMethods[v.key]?.map(m => (
                        <option key={m.value} value={m.value}>
                          {m.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShippingTable;
